import confirmDialog from 'helpers/confirmDialog';

import constants from '../../_constants/charges.constants';
import service from '../../../services/charges.service';
import alertActionCreators from '../alert.actions';

const unarchiveCharge = (charge, callback) => {
  return dispatch => {
    confirmDialog.warning({
      title: 'Restaurar Cobrança',
      message: 'Tem certeza que deseja restaurar esta cobrança?',
      confirmButtonText: 'Sim, restaurar!',
      icon: 'warning',
      onConfirm: () => {
        dispatch(request(charge.id));

        service
          .unarchive(charge.id)
          .then(() => {
            dispatch(success(charge.id));
            dispatch(alertActionCreators.success('Cobrança restaurada com sucesso!'));

            if (callback) {
              callback();
            }
          })
          .catch(error => {
            dispatch(failure(error));
          });
      },
    });

    function request(id) {
      return {
        type: constants.CHARGE_UNARCHIVE_REQUEST,
        payload: { id },
      };
    }

    function success(id) {
      return {
        type: constants.CHARGE_UNARCHIVE_SUCCESS,
        payload: { id },
      };
    }

    function failure(message) {
      return {
        type: constants.CHARGE_UNARCHIVE_FAILURE,
        payload: { message },
      };
    }
  };
};

export default unarchiveCharge;
